import { groupBy, isEmpty, uniq } from 'lodash'

// transformLineItems transforms line items into the following format:
// - line items which have the same menuItemUuid and empty modifiers are combined into one line item and the quantity is the sum of the quantities of the combined line items.
// - line items which have the same menuItemUuid and have the same modifiers are combined into one line item and the quantity is the sum of the quantities of the combined line items.
// - when above is not true, line items are not combined.

export const transformLineItems = (lineItems) => {
  if (isEmpty(lineItems)) {
    return []
  }

  const lineItemsWithoutSpecialType = lineItems?.filter((item) =>
    isEmpty(item?.itemSpecialType)
  )

  // group line items by menuItemUuid and if modifiers exists, by the modifier menuItemUuid
  const groupedLineItems = groupBy(lineItemsWithoutSpecialType, (lineItem) => {
    // sort the modifier menuItemUuid so that we can compare them later
    const sortedUniqueMenuItemUuids = uniq(
      lineItem.modifiers?.[0]?.map((modifier) => modifier.menuItemUuid).sort()
    )

    return lineItem.menuItemUuid + sortedUniqueMenuItemUuids.join('')
  })

  const transformedLineItems = Object.values(groupedLineItems).map(
    (lineItems) => {
      // combine modifiers of line items which have the same menuItemUuid and the same modifiers
      const combinedModifiers = lineItems
        .map((item) => {
          if (isEmpty(item.modifiers)) return []

          return item.modifiers?.[0]
        })
        .flat()
        .reduce((acc, item) => {
          // find the modifier which has the same menuItemUuid
          const existingModifier = acc.find(
            (modifier) => modifier.menuItemUuid === item.menuItemUuid
          )

          if (existingModifier) {
            existingModifier.quantity += item.quantity
          } else {
            // add copy of the modifier to acc in order to save object with values instead of reference
            // without this, the modifier quantity will be increased in every page refresh
            acc.push({ ...item })
          }

          return acc
        }, [])

      // combine line items which have the same menuItemUuid and empty modifiers
      const combinedLineItems = lineItems.reduce((acc, item) => {
        // add copy of the line item to acc in order to save object with values instead of reference
        // without this, the line item quantity will be increased in every page refresh
        acc = { ...item, quantity: acc.quantity || 0 }

        acc.quantity += item.quantity

        return acc
      })

      return { ...combinedLineItems, modifiers: combinedModifiers }
    }
  )

  return transformedLineItems
}
